import type { FC } from 'react'
import React from 'react'
import { CwsH4, CwsIcon } from '@components/cws'

interface FilterHeadingProps {
  title: string
  icon: 'funnel'
}

export const FilterHeading: FC<FilterHeadingProps> = ({ title, icon }) => {
  return (
    <div className="flex flex-col px-4 py-6">
      <div className="flex flex-row items-center">
        <CwsIcon size="24px" icon={icon} />
        <CwsH4 hideSpacing size="lead" className="pl-2 capitalize">
          {title}
        </CwsH4>
      </div>
    </div>
  )
}
